import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { parsePrice } from '../../../../../../lib/helper.js';
import defaultMsg from '../../../../../../translations/lang/en-US.json';

const CARD_PAYMENT_TYPE='card';
const PAYPAL_CARD_TYPE='PayPal';

class Tip extends PureComponent {
  render() {
    const { tipAmount, paymentType, cardType, onPayPal } = this.props;
    let showTip;
    let alignRigth;

    //  Keeping existent showTip conditions
    if( tipAmount && tipAmount.toString().replace(/[0\.,\t\s]/g, '').length > 0 ) {
      if (onPayPal && 
          paymentType === CARD_PAYMENT_TYPE && 
          cardType === PAYPAL_CARD_TYPE) {
        showTip=true;
        alignRigth=true;
      } else if (!onPayPal && cardType !== PAYPAL_CARD_TYPE) {
        showTip=true;
      }
    }

    return (
      <div>
      {showTip ? (
        <li>
          <FormattedMessage id="tip" defaultMessage={defaultMsg.tip} />{' '}
          {alignRigth ? <span className="pull-right">{`${parsePrice(tipAmount)}`}</span> : <div>{`( ${parsePrice(tipAmount)} )`}</div> }
        </li>
      ) : null }
      </div>
    );
  }
}

export default Tip;



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryBody/ReceiptDetails/Tip.jsx